module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-366-retro-min.94d448ad.jpg";